<script setup>
import { computed, ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import SingleSelect from 'dashboard/components-next/filter/inputs/SingleSelect.vue';

const props = defineProps({
  campaigns: {
    type: Array,
    required: true,
  },
});

const emit = defineEmits(['filterChange']);

const { t } = useI18n();
const selectedOption = ref(null);

const options = computed(() => {
  return props.campaigns.filter(({ status }) =>
    ['scheduled', 'cancelled'].includes(status)
  );
});

watch(selectedOption, value => {
  if (value) emit('filterChange', value);
});

watch(
  options,
  value => {
    if (selectedOption.value) return;
    if (value.length === 0) return;

    [selectedOption.value] = value;
  },
  { immediate: true }
);
</script>

<template>
  <SingleSelect
    v-model="selectedOption"
    :options="options"
    :placeholder="t('WGPT_CAMPAIGNS.REPORTS.FILTER_PLACEHOLDER')"
    disable-deselect
  />
</template>
